@if (isOpen) {
<div class="fixed inset-0 z-modal-top flex items-center justify-center">
  <div class="absolute inset-0 bg-black/40" (click)="cancelar()"></div>
  <div class="relative bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-md mx-4 sm:mx-6 max-h-[85vh] flex flex-col">

    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">{{ title }}</h3>
        @if (quoteNumber) {
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ quoteNumber }}</p>
        }
      </div>
      <button type="button" (click)="cancelar()" [disabled]="submitting"
        class="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors disabled:opacity-50">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-6 py-4 space-y-4">
      <p class="text-sm text-gray-600 dark:text-gray-400">{{ confirmMessage }}</p>

      @if (error) {
      <div class="px-3.5 py-3 rounded-lg bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800">
        <p class="text-xs text-error-700 dark:text-error-400">{{ error }}</p>
      </div>
      }

      <!-- Comentario opcional para el solicitante -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Comentario para el solicitante <span class="text-gray-400 dark:text-gray-500 font-normal">(opcional)</span>
        </label>
        <textarea [(ngModel)]="comment" rows="3" [disabled]="submitting" [maxlength]="COMMENT_MAX"
          placeholder="Ej. Ajustar el descuento del ítem 2 antes de reenviar"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:opacity-50 resize-none"></textarea>
        <p class="mt-1 text-xs text-gray-400 dark:text-gray-500 text-right">{{ commentLength }}/{{ COMMENT_MAX }}</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-3 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-2">
      <button type="button" (click)="cancelar()" [disabled]="submitting"
        class="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors disabled:opacity-50">
        Cancelar
      </button>
      <button type="button" (click)="confirmar()" [disabled]="submitting"
        class="px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors disabled:opacity-50 flex items-center gap-2"
        [ngClass]="confirmButtonClass">
        @if (submitting) {
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        }
        {{ actionLabel }}
      </button>
    </div>
  </div>
</div>
}
